module.exports = __webpack_public_path__ + "assets/img/team/filip-baranski.jpg";